import { clearAuthenticatedSession } from 'helpers';
import { put } from 'redux-saga/effects';

import { logOut } from 'actions';

export function* handleSagaAuthError(error: any): any {
  if (error?.status !== 401) {
    return false;
  }

  clearAuthenticatedSession();
  yield put(logOut());

  return true;
}
